<template>
    <AppLayout title="Crear envío" :contrast="true">
        <Breadcrumb name="Envíos" routeName="envios" page="Crear envío" />
        <Toast />
        <form class="p-2">
            <div class="flex flex-col lg:space-y-4 lg:flex-row lg:items-start">
                <div class="flex flex-col lg:w-1/2">
                    <RemitenteForm
                        :sucursales="sucursales"
                        :errors="errors"
                        @clearErrors="clearErrors()"
                        @updateRemitente="updateRemitente"
                    />
                    <DestinatarioForm
                        :errors="errors"
                        :destinatarios="destinatarios"
                        :selectedDestination="selectedDestination"
                        :addNewToDirectory="addNewToDirectory"
                        :updateExistingDirectory="updateExistingDirectory"
                        @changeSelectedDestination="changeSelectedDestination"
                        @updateAddNewToDirectory="updateAddNewToDirectory"
                        @updateExistingDirectoryValue="
                            updateExistingDirectoryValue
                        "
                        @updateDestinatario="updateDestinatario"
                    />
                </div>
                <PaquetesForm
                    :categorias="categorias"
                    @updatePaquetes="updatePaquetes"
                />
            </div>
            <div class="m-4 flex justify-end">
                <Button
                    :disabled="noDisponible"
                    :loading="loading"
                    @click="procesarSolicitud"
                >
                    Procesar envio
                </Button>
            </div>
            <ConsultarServiciosDialog
                :consultarServiciosDialog="consultarServiciosDialog"
                :servicios="servicios"
                :loading="loadingServicios"
                :isServerError="isServerError"
                :isNotFoundError="isNotFoundError"
                @retry="retry"
                @crearEnvio="crearEnvio"
                @closeDialog="closeDialog"
            />
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight, Plus } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import DestinatarioForm from "./components/DestinatarioForm.vue";
import RemitenteForm from "./components/RemitenteForm.vue";
import PaquetesForm from "./components/PaquetesForm.vue";
import ConsultarServiciosDialog from "./components/ConsultarServiciosDialog.vue";
import axios from "axios";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Plus,
        Breadcrumb,
        Button,
        DestinatarioForm,
        RemitenteForm,
        PaquetesForm,
        ConsultarServiciosDialog,
    },
    props: {
        sucursales: Array,
        destinatarios: Array,
        categorias: Array,
    },
    data() {
        return {
            consultarServiciosDialog: false,
            noDisponible: false,
            loading: false,
            loadingServicios: false,
            servicios: [],
            errors: null,
            isServerError: false,
            isNotFoundError: false,
            addNewToDirectory: false,
            updateExistingDirectory: false,
            selectedDestination: null,
            remitenteForm: {
                origen_nombre: "",
                origen_documento: "", //null
                origen_telefono: "", //null
                origen_email: "",
                origen_cp: "",
                origen_calle: "",
                origen_altura: "",
                origen_piso: "", //null
                origen_dpto: "", //null
                origen_localidad: "",
                origen_provincia: "",
                origen_observacion: "", //null
            },
            destinatarioForm: {
                destino_nombre: "",
                destino_documento: "", //null
                destino_telefono: "", //null
                destino_email: "",
                destino_cp: "",
                destino_calle: "",
                destino_altura: "",
                destino_piso: "", //null
                destino_dpto: "", //null
                destino_localidad: "",
                destino_provincia: "",
                destino_observacion: "", //null
            },

            paquetes: [],
        };
    },
    methods: {
        updateRemitente(remitente) {
            this.remitenteForm = remitente;
            this.noDisponible = false;
        },
        updateDestinatario(destinatario) {
            this.destinatarioForm = destinatario;
        },
        updatePaquetes(paquetes) {
            this.paquetes = paquetes;
        },
        setErrors(errors) {
            this.errors = errors;
        },
        clearErrors() {
            this.errors = null;
        },
        closeDialog() {
            this.consultarServiciosDialog = false;
            this.isServerError = false;
            this.isNotFoundError = false;
            this.servicios = null;
        },
        retry() {
            this.isServerError = false;
            this.isNotFoundError = false;
            this.servicios = null;
            this.procesarSolicitud();
        },
        changeSelectedDestination(value) {
            this.selectedDestination = value;
            console.log(value);
        },
        updateAddNewToDirectory(value) {
            if (value) {
                this.addNewToDirectory = true;
                this.updateExistingDirectory = false;
            } else {
                this.addNewToDirectory = false;
            }
        },
        updateExistingDirectoryValue(value) {
            if (value) {
                this.updateExistingDirectory = true;
            } else {
                this.updateExistingDirectory = false;
                this.addNewToDirectory = false;
            }
        },
        procesarSolicitud() {
            this.loading = true;
            axios
                .post("validar-origen-destino", {
                    ...this.remitenteForm,
                    ...this.destinatarioForm,
                })
                .then((res) => {
                    if (res.data.valido && this.paquetes.length === 0) {
                        this.clearErrors();
                        this.$toast.add({
                            severity: "warn",
                            summary: "Faltan los paquetes!",
                            detail: "Agrega por lo menos (1) paquete",
                            life: 5000,
                        });
                        this.loading = false;
                    } else if (res.data.valido) {
                        this.clearErrors();
                        this.consultarServicios();
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    if (err.response.data.errors) {
                        this.setErrors(err.response.data.errors);
                        this.$toast.add({
                            severity: "error",
                            summary: "Error en solicitud!",
                            detail: "Corrige los errores e intenta nuevamente",
                            life: 5000,
                        });
                    }
                });
        },
        consultarServicios() {
            this.consultarServiciosDialog = true;
            this.loadingServicios = true;
            axios
                .post("consultar-servicios", {
                    ...this.remitenteForm,
                    ...this.destinatarioForm,
                    paquetes: this.paquetes,
                })
                .then((res) => {
                    if (res.status === 200) {
                        this.loadingServicios = false;
                        this.servicios = res.data;
                    }
                })
                .catch((err) => {
                    if (err.response.status === 500) {
                        this.isServerError = true;
                    } else if (err.response.status === 404) {
                        this.isNotFoundError = true;
                    }
                    this.loadingServicios = false;
                });
        },
        crearEnvio(servicio_id) {
            // revisar si hay que crear un destinatario
            if (this.addNewToDirectory) {
                axios
                    .post(
                        "/directorio/crear-destinatario",
                        this.destinatarioForm
                    )
                    .then((res) => {
                        console.log(res.status);
                    })
                    .catch((err) => console.error(err.message));
                // revisar si hay que actualizar un destinatario
            } else if (this.updateExistingDirectory) {
                console.log(this.destinatarioForm);
                axios
                    .post(
                        "/directorio/actualizar-destinatario/" +
                            this.selectedDestination,
                        this.destinatarioForm
                    )
                    .then((res) => {
                        console.log(res.status);
                    })
                    .catch((err) => console.error(err.message));
            }

            this.$inertia.post(
                "crear-envio",
                {
                    ...this.remitenteForm,
                    ...this.destinatarioForm,
                    paquetes: this.paquetes,
                    servicio_id,
                },
                {
                    onError: () => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error en solicitud!",
                            detail: "Intenta nuevamente",
                            life: 5000,
                        });
                    },
                }
            );
        },
    },
};
</script>
